import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { generatePath } from 'react-router-dom';
import { Response, Pagination } from '@ui/src';
import { CurrencyItem } from '../../types';
import { currenciesApi } from '../services';
import { CurrenciesRoutes } from '../../../../routes';

export interface CurrenciesListState {
  requestInProgress: boolean;
  values?: CurrencyItem[];
  searchText: string;
  pagination?: Pagination;
}

const initialState: CurrenciesListState = {
  values: undefined,
  requestInProgress: true,
  searchText: '',
};

export const currenciesListSlice = createSlice({
  name: 'currenciesList',
  initialState,
  reducers: {
    onCurrenciesSearch: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      currenciesApi.endpoints.getConfigurationCurrencies.matchFulfilled,
      (state, action: PayloadAction<Response<CurrencyItem>>) => {
        state.values = action.payload.data.edges.map((item) => ({
          ...item.node,
          inversed: 'Inversed',
          active: true,
          url: generatePath(CurrenciesRoutes.CURRENCIES_ITEM, {
            currencyId: item.node.id,
          }),
        }));

        state.pagination = action.payload.data.pageInfo;
      },
    );
    builder.addMatcher(
      currenciesApi.endpoints.createCurrency.matchFulfilled,
      (state, action: PayloadAction<{ data: CurrencyItem }>) => {
        const nextCurrencies = ([] as CurrencyItem[]).concat(
          state.values as CurrencyItem[],
        );

        nextCurrencies.unshift({
          ...action.payload.data,
          url: generatePath(CurrenciesRoutes.CURRENCIES_ITEM, {
            currencyId: action.payload.data.id,
          }),
          active: true,
        });

        state.values = nextCurrencies;
      },
    );
  },
});

export const { onCurrenciesSearch } = currenciesListSlice.actions;

export default currenciesListSlice.reducer;
